<template>
    <div class="spinner">
        <a class="minus spin-button minus" @click="updateQuantity('-')"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></a>
        <input name="quantity" type="number" :step="step" :min="step" v-model.number="quantity" @change="setQuantity">
        <span class="suffix">{{ mu }}</span>
        <a class="plus spin-button plus" @click="updateQuantity('+')"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M416 208H272V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v144H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h144v144c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V304h144c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32z"/></svg></a>
    </div>
</template>

<script>
import {ref} from 'vue'
import emitter from '../../utils/emitter'

export default {
    props: ['mu','step'],

    setup(props) {
        const quantity = ref(1)

        function setQuantity() {
            emitter.emit('updateQuantity', quantity)
        }

        function updateQuantity(action) {
            let step = props.step ?? 1

            if (step % 1 !== 0) {
                step = parseFloat(step)
            } else {
                step = parseInt(step)
            }

            if ( action === '+' ) quantity.value += step
            else quantity.value -= step
            if (quantity.value < step) quantity.value = step

            if (quantity.value % 1 !== 0) {
                quantity.value = parseFloat(quantity.value.toFixed(2))
            }

            setQuantity()
        }

        return {
            quantity,
            setQuantity,
            updateQuantity
        }
    }
}
</script>
